/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SparePartsOverviewOutput } from '../../models/spare-parts-overview-output';

export interface GetSparePartsOverview$Params {
  SerialNumber: string;
  MaterialNumber: number;
  StartDate: string;
  EndDate: string;
}

export function getSparePartsOverview(http: HttpClient, rootUrl: string, params: GetSparePartsOverview$Params, context?: HttpContext): Observable<StrictHttpResponse<SparePartsOverviewOutput>> {
  const rb = new RequestBuilder(rootUrl, getSparePartsOverview.PATH, 'get');
  if (params) {
    rb.path('SerialNumber', params.SerialNumber, {});
    rb.path('MaterialNumber', params.MaterialNumber, {});
    rb.path('StartDate', params.StartDate, {});
    rb.path('EndDate', params.EndDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SparePartsOverviewOutput>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getSparePartsOverview.PATH = '/api/SpareParts/SparePartsOverview/{SerialNumber}/{MaterialNumber}/{StartDate}/{EndDate}';
getSparePartsOverview.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getSparePartsOverview.ROOTURL = '/spareparts';
